export default "__VITE_ASSET__ChdRW1VZ__"